import {useLocation, useNavigate} from "react-router-dom";
import {timeZone} from "@ots-frontend/ots-data";
import {useApp} from "@ots-frontend/ots-ui";
import {HasAccess, OtsInlineAlert, ShiftFormPage} from "@ots-frontend/ots-ui-tw";
import {type ShiftFormRouteState, shiftDraftFromRouteState} from "./shift-form-route-state";

/** `/shifts/form`: the shared Tailwind shift form, opened with the same route state as the Mantine page it replaces. */
export const ShiftFormPageRoute = () => {
  const navigate = useNavigate();
  const {regionId} = useApp();
  const state = useLocation().state as ShiftFormRouteState | null;
  const editing = !!state?.id && !state.copy;

  return (
    <HasAccess
      permissions={[editing ? "shift_edit" : "shift_create"]}
      empty={<OtsInlineAlert tone="warning" title="You can't change shifts" className="m-6">
        Ask an administrator for access to {editing ? "edit" : "create"} shifts.
      </OtsInlineAlert>}>
      <ShiftFormPage
        shiftId={state?.id}
        copy={state?.copy}
        draft={shiftDraftFromRouteState(state)}
        regionId={regionId}
        timeZone={timeZone.value}
        onClose={() => navigate(-1)}/>
    </HasAccess>
  );
};
